/**
 * Ce qui s'ouvre par-dessus l'onglet Messages de la fiche : les fenêtres de la conversation de l'élève
 * (« Copier », un numéro touché, la visionneuse, le bandeau d'un fichier qui n'est pas parti,
 * l'enregistreur d'un vocal), plus l'aperçu d'un fichier du tuteur (`<TutorMediaPreviewModal>`) et la
 * visionneuse plein écran de sa photo. Des fenêtres du design system, contrôlées par
 * `useTutorStudentMessagesTab`.
 */
import React from "react"

import { MediaDisplay } from "../../../../../../design-system"
import { TutorMediaPreviewModal } from "../../../../../../design-system/tutor"
import { type TutorMediaPreviewModalProps } from "../../../../../../design-system/templates/TutorMediaPreviewModal/TutorMediaPreviewModal"
import {
    StudentTutorConversationOverlays,
    type StudentTutorConversationOverlaysProps,
} from "../../student/Messaging/StudentTutorConversationOverlays"

export type TutorStudentMessagesOverlayProps = {
    conversation: StudentTutorConversationOverlaysProps
    /** L'aperçu d'un fichier ; `null` : fermé. */
    preview: Omit<TutorMediaPreviewModalProps, "visible" | "testID"> | null
    /** La visionneuse de la photo de l'aperçu ; `null` : fermée. */
    viewer: { images: { uri: string }[]; index: number; onClose: () => void } | null
}

export function TutorStudentMessagesOverlay(props: TutorStudentMessagesOverlayProps) {
    const { conversation, preview, viewer } = props
    return (
        <>
            <StudentTutorConversationOverlays {...conversation} />
            {preview != null && <TutorMediaPreviewModal visible {...preview} />}
            {viewer != null && (
                <MediaDisplay
                    kind="image"
                    visible
                    images={viewer.images}
                    initialIndex={viewer.index}
                    onClose={viewer.onClose}
                />
            )}
        </>
    )
}
